
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 276.5 269.6"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M137.8 0L33 49.8c-6.7 3.1-6 1.8-7.6 9.4L6.2 143.3c-8.7 37.6-9.9 23.7 7.1 46.5l30.6 38.7c39.5 47.8 23.2 40.8 61 40.8l86.3.1c13.5.1 10.6-3 27.4-23.4 5.4-6.5 10.4-13.2 15.6-19.7 10.7-13.3 20-24.7 30.3-37.7 4.3-5.4 13.2-12.8 11.9-19.7-1.6-8.9-4.6-19.6-6.7-28.7-4.2-18.3-8.5-37.4-12.6-55.4-2-8.9-3.8-19.2-6.2-27.8-2-7.2-8.9-7.7-21.5-13.9C218.5 37.8 139.9-.6 137.8 0z","fill":"#fcaa00"}}),_c('path',{attrs:{"d":"M116.9 246.8l2.5-15.7c-40-5.1-74.4-46.5-74.5-90.4C44.6 35.5 187.6 12 225 104.3c9 22.1 9 46.9.6 69.4-6.5 17.5-23.7 39.2-38.6 45.2l-7.2-11.5c-3.4 2.3-23 35.4-23.8 40.3l47.5-1.2c-2-6-5.6-8.7-7.1-14.4 60-32.5 76.5-138.2-2.1-186-69-42-165.1 5.2-165.1 94.6-.1 53.5 42.4 101.2 87.7 106.1zM84.4 116.5l35.1.7c-.1-7.5-.1-10 2-15.3 6.7-1.9 28-3.2 34.4.1 5.1 5.3 4 17.3-.2 22.2-11.5 13.8-34.7 26.8-33.3 49.3l33.5.1c8.9-13.1.6-5.2 16.5-19.7 5.1-4.7 12.4-13 16.4-20.2 8.6-15.5 7.7-49.6-5.6-58.9-9.5-6.7-55.4-4-70.5-3.9-28.5.2-29.1 19.2-28.3 45.6zm37.5 103.1l34.7.1v-33l-34.2-.3-.5 33.2z","fill":"#fefefe"}})])])
          )
        }
      }
    